import {ReactNode} from 'react';

export interface VirtualWarehouseGridRawRowResponse {
    participant: string;
    productName: string;
    gtin: string;
    incomeCount: number;
    expenseCount: number;
    remainCount: number;
    remainStartCount: number;
    productTrademark: string;
    productGroupCode: string;
    storageName: string;
    storageAddress: string;
    markingCodes: {code: string; packagingType: string}[];
}

export interface VirtualWarehouseGridRawRow {
    participant?: string;
    productName: string;
    gtin: string;
    incomeCount: number;
    expenseCount: number;
    remainCount: number;
    remainStartCount: number;
    productTrademark: string;
    productGroupCode: string;
    code: string;
    type: string;
    storageName: string;
    storageAddress: string;
    owner?: string;
    codesCount?: number;
}

export enum VirtualWarehouseGridAccessors {
    participant = 'participant',
    name = 'productName',
    gtin = 'gtin',
    income = 'incomeCount',
    expense = 'expenseCount',
    balanceStart = 'remainStartCount',
    balance = 'remainCount',
    trademark = 'productTrademark',
    groupCode = 'productGroupCode',
    code = 'code',
    type = 'packagingType',
    storageName = 'storageName',
    storageAddress = 'storageAddress',

    codesCount = 'codesCount',
    owner = 'owner',
}

export interface VirtualWarehouseGridFormattedRow {
    [VirtualWarehouseGridAccessors.participant]?: string;
    [VirtualWarehouseGridAccessors.name]: string;
    [VirtualWarehouseGridAccessors.gtin]: string;
    [VirtualWarehouseGridAccessors.code]: string;
    [VirtualWarehouseGridAccessors.type]: string;
    [VirtualWarehouseGridAccessors.income]: string;
    [VirtualWarehouseGridAccessors.expense]: string;
    [VirtualWarehouseGridAccessors.trademark]: string;
    [VirtualWarehouseGridAccessors.groupCode]: string;
    [VirtualWarehouseGridAccessors.balance]: ReactNode;
    [VirtualWarehouseGridAccessors.balanceStart]?: ReactNode;
    [VirtualWarehouseGridAccessors.codesCount]?: number;
    [VirtualWarehouseGridAccessors.owner]?: string;
    [VirtualWarehouseGridAccessors.storageName]?: string;
    [VirtualWarehouseGridAccessors.storageAddress]?: string;
}
